
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match-booster/configure-model",
      function () {
        return require("private-next-pages/match-booster/configure-model.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match-booster/configure-model"])
      });
    }
  